/**
 * The fixed width of the popup element.
 * @type {number}
 */
export const popupWidth = '--popup-width';
/**
 * The fixed height of the popup element.
 * @type {number}
 */
export const popupHeight = '--popup-height';
